module.exports = __webpack_public_path__ + "static/media/animal.b73dcbb2.svg";